import React from 'react'
import { colors } from '../../Colors'

export interface IProps {
    width?: number
    height?: number
    color?: string
}

const SuccessIcon = ({ width, height, color }: IProps) => {
    return (
        <svg
            xmlns='http://www.w3.org/2000/svg'
            width={width ?? 24}
            height={height ?? 24}
            viewBox='0 0 24 24'
            fill='none'
        >
            <path
                d='M12.0004 2.3999C6.69879 2.3999 2.40039 6.6983 2.40039 11.9999C2.40039 17.3015 6.69879 21.5999 12.0004 21.5999C17.302 21.5999 21.6004 17.3015 21.6004 11.9999C21.6004 6.6983 17.302 2.3999 12.0004 2.3999ZM17.366 10.1655L11.318 16.2135C11.1676 16.3639 10.9644 16.4479 10.7524 16.4479C10.5404 16.4479 10.3364 16.3639 10.1868 16.2135L7.42439 13.4511C7.11159 13.1383 7.11159 12.6327 7.42439 12.3199C7.73719 12.0071 8.24279 12.0071 8.55559 12.3199L10.7524 14.5167L16.2348 9.0343C16.5476 8.7215 17.0532 8.7215 17.366 9.0343C17.6788 9.3471 17.6788 9.8527 17.366 10.1655Z'
                fill={color ?? colors.grey[50]}
            />
        </svg>
    )
}

export default React.memo(SuccessIcon)
